import { render, staticRenderFns } from "./MessageBlock.vue?vue&type=template&id=1d0fecea&scoped=true"
import script from "./MessageBlock.vue?vue&type=script&lang=ts"
export * from "./MessageBlock.vue?vue&type=script&lang=ts"
import style0 from "./MessageBlock.vue?vue&type=style&index=0&id=1d0fecea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fecea",
  null
  
)

export default component.exports